import ModuleBase from "./moduleBase";
import {
  Mate,
  MateModule,
  ModuleEntityType,
  ModuleQuestion,
  Worldview,
} from "@/types/entity";
import ModuleBaseImpl from "./moduleBaseImpl";
import { useGlobalUser } from "../globalUser";
import { useWorldview } from "../worldview";
import {
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import i18n from "@/locales";
import { AxiosError } from "axios";

export const BASIC_INFO_MODULE_ID = 337; // 基本信息
export const TIMELINE_MODULE_ID = 338; // 时间线
export const BIOLOGY_MODULE_ID = 339; // 生物
export const GALLERY_MODULE_ID = 369; // 画廊

class ModuleWorldview extends ModuleBase implements ModuleBaseImpl {
  constructor(
    entity: Mate | Worldview,
    entityType: ModuleEntityType,
    mateModuleList: MateModule[],
    moduleQuestionMap: Record<number, ModuleQuestion[]>
  ) {
    super(entity, entityType, mateModuleList, moduleQuestionMap);

    this.initMateModuleOrder();
    this.initModuleList();
  }

  canEditModule(moduleId: number): boolean {
    return !this.moduleIdMap[moduleId].isPreset;
  }

  canDeleteModule(moduleId: number): boolean {
    if (moduleId === BIOLOGY_MODULE_ID) return true;
    return !this.moduleIdMap[moduleId].isPreset;
  }

  canExportModule(moduleId: number): boolean {
    if (moduleId === BIOLOGY_MODULE_ID) return true;

    return !this.moduleIdMap[moduleId].isPreset;
  }

  async updateEntityOrder(): Promise<void> {
    if (useGlobalUser().user.id !== this.entity.userId) return;
    this.entity.moduleOrder = this.entity.moduleOrder.filter(
      (v) => v.id !== undefined
    );
    await useWorldview().updateWorldview(this.entity.id!, {
      moduleOrder: this.entity.moduleOrder,
    });
    return;
  }

  async publish(): Promise<void> {
    // await useWorldview().publish(this.entity.uuid);
    await useWorldview().updateWorldview(this.entity.id!, {
      status: 1,
    });
    this.entity.status = 1;
  }

  async deleteEntity(): Promise<void> {
    if (useWorldview().worldviewList.length === 1) {
      showFailToast(i18n.global.t("Message.cannotDeleteThisPlanet2"));
      return;
    }

    try {
      await showConfirmDialog({
        message: i18n.global.t("ConfirmModal.deleteModuleAllInfo"),
        confirmButtonText: i18n.global.t("Buttons.confirm"),
        cancelButtonText: i18n.global.t("Buttons.cancel"),
      });
    } catch {
      return;
    }
    const toast = showLoadingToast({
      message: i18n.global.t("Message.deleting"),
      duration: 0,
    });
    try {
      await useWorldview().deleteWorldview(this.entity.id!);
      toast.close();
      showSuccessToast(i18n.global.t(`Message.deleteSuccessful`));
      await new Promise((r) => setTimeout(r, 1000));
      window.$router.back();
    } catch (e: unknown) {
      toast.close();
      if (e instanceof AxiosError) {
        const msg = e.response?.data?.message;
        if (msg === "不能删除这个星球" || msg === "Cannot delete this planet") {
          showFailToast(i18n.global.t("Message.cannotDeleteThisPlanet"));
        }
      } else {
        console.log("Unknown error:", e);
      }
    }
  }
}

export default ModuleWorldview;
